import React, { useRef } from 'react';

/** 6-digit OTP entry as individual boxes. value/onChange are plain strings, same contract as a text input. */
export default function OtpBoxInput({ value, onChange, disabled }) {
  const refs = useRef([]);
  const digits = value.padEnd(6, ' ').split('').map((d) => (d === ' ' ? '' : d));

  function setDigitAt(i, d) {
    const next = digits.slice();
    next[i] = d;
    onChange(next.join('').trimEnd());
    if (d && i < 5) refs.current[i + 1]?.focus();
  }

  function handleKeyDown(i, e) {
    if (e.key === 'Backspace' && !digits[i] && i > 0) refs.current[i - 1]?.focus();
  }

  function handlePaste(e) {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    if (pasted) { onChange(pasted); refs.current[Math.min(pasted.length, 5)]?.focus(); }
  }

  return (
    <div className="otp-box-row" onPaste={handlePaste}>
      {digits.map((d, i) => (
        <input
          key={i}
          ref={(el) => { refs.current[i] = el; }}
          type="text"
          inputMode="numeric"
          maxLength={1}
          className="otp-box"
          value={d}
          disabled={disabled}
          onChange={(e) => setDigitAt(i, e.target.value.replace(/\D/g, '').slice(-1))}
          onKeyDown={(e) => handleKeyDown(i, e)}
          aria-label={`Digit ${i + 1} of 6`}
        />
      ))}
    </div>
  );
}
